import { render, staticRenderFns } from "./opportunity.vue?vue&type=template&id=1f644fb5&"
import script from "./opportunity.vue?vue&type=script&lang=js&"
export * from "./opportunity.vue?vue&type=script&lang=js&"
import style0 from "./opportunity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports